import request from '@/utils/request'

// 521领取活动卡
export function loveBindCard(params) {
    return request({
        url: `/tour-product/wxusercard/loveBindCard`,
        method: 'POST',
        params
    })
}